import { fetchConfig, serializeForm } from '../js/global-exports.js';

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if(!this.form) {return;}
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    setB2bSubmitBtnLoadingMode(mode,submitButton,spinner,feedback) {
      if(mode === 'loading') {
        submitButton.classList.add('button--hide-text');
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        spinner.classList.remove('hidden');
        submitButton.classList.remove('button--feedback');
        feedback.classList.add('hidden');
      } else if (mode === 'success') {
        submitButton.classList.remove('loading');
        setTimeout(()=>{
          submitButton.classList.add('button--feedback');
          submitButton.classList.remove('button--hide-text');
        })
        submitButton.removeAttribute('aria-disabled');
        spinner.classList.add('hidden');
        feedback.classList.remove('hidden');
      } else {
        spinner.classList.add('hidden');
        submitButton.removeAttribute('aria-disabled');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      let spinner = null;
      let feedback = null;

      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      if(window.isB2cSite === true) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      } else if(window.isB2bSite === true) {
        spinner = this.querySelector('.loading-overlay__spinner');
        feedback = this.querySelector('.feedback--success');
        this.setB2bSubmitBtnLoadingMode('loading', submitButton, spinner, feedback);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            if(window.isB2bSite === true) {
              this.setB2bSubmitBtnLoadingMode('error', submitButton, spinner, feedback);
            }
            return;
          }

          this.cartNotification.renderContents(response, false);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if(window.isB2cSite === true) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          } else if(window.isB2bSite === true) {
            this.setB2bSubmitBtnLoadingMode('success', submitButton, spinner, feedback);
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
